<template>
  <el-container id="layout">
    <el-header class="nav-header">
      <el-row align="middle" class="nav-header-message">
        <el-col :span="20" class="nav-header-title">
          <router-link tag="span" to="/manage">格隆汇信息科技活动系统</router-link>
          <span class="time">{{time}}</span>
        </el-col>
        <el-col :span="4" class="nav-header-link">
          <span class="logout-button" @click="logout">退出登录</span>
        </el-col>
      </el-row>
    </el-header>
    <el-container>
      <el-aside :class="['nav',show?'show':'hidden']">
        <elenav></elenav>
      </el-aside>
      <el-main style="position: relative;">
        <div class="btn-show" @click="show = !show">{{show?'<':'>'}}</div>
        <transition name="fade" mode="out-in">
          <router-view :user="user" :role="role" :userIfo="userIfo"></router-view>
        </transition>
      </el-main>
    </el-container>
  </el-container>
</template>

<script>
import elenav from "./backend/nav.vue";
import moment from "moment";

export default {
  name: "HelloWorld",
  data() {
    return {
      msg: "Welcome to Your Vue.js App",
      user: "",
      role: "",
      name: "",
      time: "",
      userIfo: {
        user: "",
        role: "",
        name: ""
      },
      show: true
    };
  },
  methods: {
    logout() {
      this.$http.user_logout().then(res => {
        this.$router.push("/login");
      });
    },
    statusCheck() {
      this.$http.user_check().then(res => {
        if (res.data.statusCode === 200) {
          this.user = res.data.result.user;
          this.role = res.data.result.level;
          this.name = res.data.result.name;
          this.userIfo.user = res.data.result.user;
          this.userIfo.role = res.data.result.level;
          this.userIfo.name = res.data.result.name;
          this.$message({
            showClose: true,
            message: `ヾ(๑╹◡╹)ﾉ"欢迎~${res.data.result.name},级别: ${res.data.result.level}`,
            type: "success"
          });
        } else {
          this.$router.push("/login");
          this.$message({
            message: "登录状态过期,请重新登录",
            type: "error",
            center: true
          });
        }
      });
    },
    getTime() {
      setInterval(() => {
        this.time = moment().format("YYYY-MM-DD hh:mm:ss");
      }, 1000);
    }
  },
  components: {
    elenav
  },
  mounted() {
    this.statusCheck();
    this.getTime();
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style>
#layout {
  height: 100vh;
  width: 100vw;
}

.main h1 {
  text-align: center;
  padding: 50px;
}

.nav-header {
  background: #20a0ff;
}

.nav-header-message {
  line-height: 60px;
}

.nav-header-message span {
  cursor: pointer;
}

.nav-header-title span:hover {
  color: gray;
}

.nav-header-title {
  font-size: 20px;
  font-weight: bold;
  color: white;
}

.nav-header-link {
  color: white;
}

.logout-button:hover {
  color: #fa5555;
}

.fade-enter-active,
.fade-leave-active {
  transition: all 0.2s ease;
}

.fade-enter,
.fade-leave-active {
  opacity: 0;
}

.table-container h1 {
  padding: 10px;
}

.table-container {
  width: 800px;
}

/* @media (max-width: 1440px) {
  .el-aside {
    zoom: 0.65;
  }
} */
.nav-header-title .time {
  font-size: 14px;
  margin-left: 10px;
}

.nav {
  transition: margin-left 400ms;
}

@media (max-width: 1440px) {
  .nav {
    zoom: 0.7;
    /* width: 250px !important; */
  }
}

.show {
  margin-left: 0;
}

.hidden {
  margin-left: -300px;
}

.btn-show {
  position: absolute;
  top: 0;
  left: 0;
  font-size: 24px;
  z-index: 1;
  cursor: pointer;
}

#hkstockspost .el-form-item > div {
  display: flex;
}

.hkstock-post .el-input input {
  border: 1px solid #d8d8d8;
}
</style>



// WEBPACK FOOTER //
// src/components/index.vue